import React, {useContext, useEffect, useState} from 'react';
import FontAwesome from "../utilities/FontAwesome";
import styles from "../../pages/styles/MainGridPage.module.scss";
import followStyles from "./styles/FollowFeedPageItem.module.scss"
import PropTypes from "prop-types";
import {getQueries} from "../../utils/SchoolBlocksUtilities";
import {StoreContext} from "../../stores/StoreLoader";

function FollowPageButton(props) {
    const {modalStore, userStore} = useContext(StoreContext);

    const [followIcon, setFollowIcon] = useState(null);
    const [followText, setFollowText] = useState(null);

    function openLoginModal() {
        modalStore.addModal({
            type: 'login',
            id: 'login-modal',
        })
    }

    useEffect(() => {
        if (props.symbolOnly) {
            if (props.follower) {
                setFollowIcon(<FontAwesome prefix={'fas'} name={'fa-star'} size={props.smallIcon ? undefined : props.size}/>)
            }
            else {
                setFollowIcon(<FontAwesome name={'fa-star'} prefix={'far'} size={props.smallIcon ? undefined : props.size}/>)
            }
        }
        else {
            if (props.follower) {
                setFollowIcon(<FontAwesome prefix={'fas'} name={'fa-star'} id="sb-follow-button-icon"/>);
                setFollowText(<div className={followStyles.hiddenWhenSmall} id="sb-follow-button-text" aria-label="Click to stop following">Following</div>);
            }
            else {
                setFollowIcon(<FontAwesome name={'fa-star'} prefix={'far'} id="sb-follow-button-icon"/>);
                setFollowText(<div className={followStyles.hiddenWhenSmall} id="sb-follow-button-text" aria-label="Click to follow">Follow</div>);
            }
        }
    },[props.follower, props.smallIcon])

    return (
        <>
            {props.symbolOnly ? <button
                onClick={userStore.id ? props.toggleFollowing: openLoginModal}
                className={props.className}
                title="Follow / Unfollow Organization"
                aria-label="Follow / Unfollow Organization">
                {followIcon}
            </button> :
            <button onClick={userStore.id ? props.toggleFollowing: openLoginModal}
                    className={`btn btn-default pull-right ${styles.classroomFollowFloatingButton}`}>
                {followIcon}
                {followText}
            </button>}
        </>
    );
}

FollowPageButton.propTypes = {
    symbolOnly: PropTypes.bool,
    follower: PropTypes.bool.isRequired,
    setFollower: PropTypes.func,
    toggleFollowing: PropTypes.func.isRequired,
    className: PropTypes.string,
    smallIcon: PropTypes.bool,
    size: PropTypes.string,
};

export default FollowPageButton;
